import { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import API from '../../api/api';


const TieOnInfoForm = ({ runId, onSuccess, isNewProject }) => {
  const [formData, setFormData] = useState({
    md: '',
    tvd: '',
    inc: '',
    az: '',
    ns: '',
    ew: '',
  });
  const [loading, setLoading] = useState(false);
  const [hasFetchedData, setHasFetchedData] = useState(false);

  // Fetch tie on info when runId changes (for existing projects)
  useEffect(() => {
    const fetchTieOnInfo = async () => {
      // Don't fetch for new projects
      if (isNewProject || !runId || hasFetchedData) return;
      
      try {
        const res = await API.get(`/tieons/?run=${runId}`);
        if (res.data && res.data.length > 0) {
          setFormData(res.data[0]);
        }
        setHasFetchedData(true);
      } catch (err) {
        console.error('Error fetching tie on info:', err);
      }
    };
    
    fetchTieOnInfo();
  }, [runId, isNewProject, hasFetchedData]);

  if (!runId) {
    return <p className="text-red-600">Please save Run Info before adding Tie On info.</p>;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleTieOnFromSurface = () => {
    setFormData({
      md: '0',
      tvd: '0',
      inc: '0',
      az: '0',
      ns: '0',
      ew: '0',
    });
    toast.success('Filled all fields with zero from surface.');
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      let response;
      if (formData.id) {
        // Update existing tie on info
        response = await API.put(`/tieons/${formData.id}/`, { ...formData, run: runId });
        toast.success('Tie On info updated!');
      } else {
        // Create new tie on info
        response = await API.post('/tieons/', { ...formData, run: runId });
        toast.success('Tie On info saved!');
      }
      
      if (onSuccess) onSuccess(response.data);
    } catch (err) {
      toast.error('Failed to save Tie On info.');
      console.error('Error:', err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 border rounded-lg shadow-md max-w-3xl mx-auto bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-200 mt-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
        {[
      { label: 'Measured Depth', name: 'md', step: '0.01', unit: 'm' },
      { label: 'TVD', name: 'tvd', step: '0.01', unit: 'm' },
      { label: 'Inclination', name: 'inc', step: '0.01', unit: 'deg' },
      { label: 'Azimuth', name: 'az', step: '0.01', unit: 'deg' },
      { label: '+N/-S', name: 'ns', step: '0.01', unit: 'm' },
      { label: '+E/-W', name: 'ew', step: '0.01', unit: 'm' },
    ].map(({ label, name, step, unit }) => (
      <label key={name} className="block">
        <span className="text-xs font-medium">{label}</span>
        <div className="relative mt-1">
          <input
            type="number"
            step={step}
            name={name}
            value={formData[name] || ''}
            onChange={handleChange}
            className="block w-full pr-10 rounded-md border border-gray-300 dark:border-gray-600 px-3 py-2 bg-white dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs"
          />
          <span className="absolute inset-y-0 right-2 flex items-center text-gray-500 text-xs">{unit}</span>
        </div>
      </label>
    ))}
      </div>

      <div className="flex justify-end gap-4">
        <button
          onClick={handleTieOnFromSurface}
          disabled={loading}
          className="px-2 py-2 rounded-md font-semibold text-white bg-gray-500 hover:bg-gray-700 transition text-xs"
        >
          Tie On From Surface
        </button>
        <button
          onClick={handleSubmit}
          disabled={loading}
          className={`px-4 py-2 rounded-md text-xs font-medium text-white ${
            loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'
          } transition`}
        >
          {loading ? 'Submitting...' : formData.id ? 'UPDATE TIE ON INFO' : 'SAVE TIE ON INFO'}
        </button>
      </div>
    </div>
  );
};

export default TieOnInfoForm;